export default __webpack_public_path__ + "v1.18.25/static/media/LibreDataShare.42dcc986.svg";